import { createSelector } from 'reselect'
import { get } from 'lodash'

import key from './types'
import { initialState } from './reducer'

const selectImports = state => get(state, key, initialState)

const selectLoading = createSelector(
  selectImports, state => get(state, 'loading', null)
)

const selectListLoading = createSelector(
  selectImports, state => get(state, 'listLoading', null)
)

const selectSuccess = createSelector(
  selectImports, state => get(state, 'importsList', [])
)

const selectColumns = createSelector(
  selectImports, state => get(state, 'columns', [])
)

const selectPages = createSelector(
  selectImports, state => get(state, 'pages', null)
)

const selectTotalItems = createSelector(
  selectImports, state => get(state, 'totalItems', 0)
)

const selectError = createSelector(
  selectImports, state => get(state, 'error', null)
)

const selectDataFilters = createSelector(
  selectImports, state => get(state, 'dataFilters', [])
)

const selectDataFiltersErrorError = createSelector(
  selectImports, state => get(state, 'dataFiltersError', null)
)

const selectUploadFileInfo = createSelector(
  selectImports, state => get(state, 'uploadFileInfo', null)
)

const selectJobTypes = createSelector(
  selectImports, state => get(state, 'jobTypes', null)
)

const selectAddImprtInformation = createSelector(
  selectImports, state => get(state, 'addImprtInformation', null)
)

export default {
  SUCCESS: selectSuccess,
  COLUMNS: selectColumns,
  ERROR: selectError,
  LOADING: selectLoading,
  LIST_LOADING: selectListLoading,
  PAGES: selectPages,
  TOTAL_ITEMS: selectTotalItems,
  FILTER_OBJECT: selectDataFilters,
  ERROR_FILTER_OBJECT: selectDataFiltersErrorError,
  UPLOAD_FILE_INFO: selectUploadFileInfo,
  JOB_TYPES: selectJobTypes,
  ADD_PERSON_INFORMATION: selectAddImprtInformation
}
